import React, {useContext,useEffect,useState} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import { ArrowDownIcon } from '@heroicons/react/16/solid';
import {useParams} from 'react-router-dom'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia} from '@mui/material'
import Axios from 'axios'
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import {NuevaInscripcionNew} from './NuevaInscripcionNew'

export const ETInscripcionItem = ({id})=>{
    const {buscarPreguntasFrecuentes} = useContext(formularioContext)
    const [eventoValor,setEventoValor]= useState(null)
    const { datos,
        handleChangeMinistroUad,
        descripcionProvincia,
        handleChangeDocumento,
        reinicializar,
        reinicializarConyuge,
        buscarDatosMinistro,
        validarMinistroEventoSeleccionado,
        datosMinistroOk,pedirDatosMinExterno,setPedirDatosMinExterno} = useContext(formularioContext)
        const [loading,setLoading]=useState(false);
    const [datosMinistroUad,setDatosMinistroUad]= useState(null)


    const parametros = useParams()


        useEffect(()=>{

           const obtenerEventoValor = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/info/eventosvalor/${parametros?.id_evento_valor}`:`https://uadapi.uad.digital/documentos/info/eventosvalor/${parametros?.id_evento_valor}`)
                setEventoValor(data)
              
            }catch(err){
                console.log('Error loading events',err)
            }
           
        }

        if(parametros?.id_evento_valor){
            obtenerEventoValor()
        }
    },[parametros])

    const validarDNI = ()=>{
        setLoading(true)
        buscarDatosMinistro() // sea ministro uad o no voy a verificar que el DNI está en la base de datos
        .then(info=>{
            if(!info){
                setLoading(false)
                alert('no info')
            }else{
               setLoading(false)
               setDatosMinistroUad(info)
                alert(JSON.stringify(info))
            }
        })
        .catch(err=>{
            setLoading(false)
            Swal.fire({
                html:`<p>${err.message}</p>`,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            }) 
        })
    }

    const processHandleChangeDNI = (e)=>{
        handleChangeDocumento(e)
    }

    return  <Grid container spacing={3} sx={{ p: { xs: 2, md: 16 } }}>
        <Grid item xs={12}>
            {/* <h1>{JSON.stringify(datos)}</h1> */}
            <h1 className='text-lg'>{datos.ministroUad}</h1>
        
                {!datos.ministroUad && <Box
                    sx={{
                    marginTop: '1rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    width: '100%',
                    }}
                >
                    <TextField
                    autoFocus
                    value={datos.documento}
                    onChange={(e) => processHandleChangeDNI(e)}
                    fullWidth
                    id="ub-dni"
                    inputProps={{ maxLength: 9, placeholder: 'DNI' }}
                    label="Ingrese su DNI"
                    variant="outlined"
                    />

                    {datos.documento && (
                        <Box sx={{ width: '100%' }}>
                            <Button
                            title="Continuar"
                            disabled={
                                datos.documento.trim() === '' || datos.documento.trim().length < 7
                            }
                            variant="contained"
                            color="primary"
                            sx={{
                                width: '100%',
                                backgroundColor: '#1976d2', // Azul relleno
                                color: 'white',
                                '&:hover': {
                                backgroundColor: '#1565c0', // Azul más oscuro al pasar el mouse
                                },
                            }}
                            onClick={validarDNI}
                            >
                            Continuar
                            </Button>
                        </Box>
                        )}
                </Box>}
                {datos.ministroUad=='ministrouad' && <Box>
                    <h1>Sesión de {datosMinistroUad?.nombre} </h1>
                    <Button onClick={reinicializar}>Cancelar</Button>
                </Box>}
                {datos.ministroUad=='externo' && <Box>
                    <h1>Sesión de documento número: {datos.documento} </h1>
                    <Button onClick={reinicializar}>Cancelar</Button>
                </Box>}
        </Grid>
        <Grid xs={12}>
                    {eventoValor && <>
                        {validarMinistroEventoSeleccionado(null,eventoValor)[0] && <NuevaInscripcionNew id_evento={parametros?.id_evento}  eventoValorSeleccionado={eventoValor}/>}
                        {!validarMinistroEventoSeleccionado(null,eventoValor)[0] && <p>{validarMinistroEventoSeleccionado(null,eventoValor)[1]}</p>}
                    </>}          
        </Grid>
    </Grid>
}

